<template>
  <div class="retirement-self detail-item">
    <div class="head"><b>自己都合退職</b></div>
    <div class="data">
      <p class="pre">{{ Message.RETIREMENT_SELF }}</p>
    </div>

  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import Message from "@/const/KoyouKeiyaku/Message";

export default defineComponent({
  setup() {

    return {
      Message
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/koyoukeiyaku.scss';
@import '@scss/components/koyoukeiyaku-detail.scss';

</style>
